import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LazySystemOperationsPage } from '@confluence/site-permissions/entry-points/SystemOperationsPage.ts';

const SYSTEM_OPERATIONS_ANALYTICS_SOURCE = 'adminSystemOperations';

export const SystemOperationsRoute = () => <LazySystemOperationsPage />;
SystemOperationsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: SYSTEM_OPERATIONS_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
